export default "__VITE_ASSET__DlDBO$ct__"